import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";

gsap.registerPlugin(ScrollTrigger, SplitText);

const hiddenButton2 = document.querySelector('.js-hidden-button-2');
const targetButton2 = document.querySelector('.js-button-2');
const hiddenButton = document.querySelector('.js-hero-hidden-button');
const targetButton = document.querySelector('.js-hero-button');

hiddenButton?.addEventListener('mouseenter', () => {
  targetButton.classList.add('active');
});

hiddenButton?.addEventListener('mouseleave', () => {
  targetButton.classList.remove('active');
});

hiddenButton2?.addEventListener('mouseenter', () => {
  targetButton2.classList.add('active');
});

hiddenButton2?.addEventListener('mouseleave', () => {
  targetButton2.classList.remove('active');
});

const pinTitleMains = document.querySelectorAll('.hero__title');
const pinTitles = document.querySelectorAll('.hero__subtitle');
const pinButtons = document.querySelectorAll('.hero__buttons');

pinTitleMains.forEach((pinTitleMain) => {
  ScrollTrigger.create({
    trigger: pinTitleMain,
    start: "bottom bottom",
    toggleActions: "play none none none",
    scrub: false,
    onUpdate: (self) => {
      const progress = self.progress;
      const y = -200 * progress;
      gsap.to(pinTitleMain, {
        y: y,
        ease: 'none',
        overwrite: 'auto',
        duration: 0.1,
      });
    },
  });
});

pinTitles.forEach((pinTitle) => {
  ScrollTrigger.create({
    trigger: pinTitle,
    start: "bottom bottom",
    toggleActions: "play none none none",
    scrub: true,
    onUpdate: (self) => {
      const progress = self.progress;
      const y = -150 * progress;
      gsap.to(pinTitle, {
        y: y,
        ease: 'none',
        overwrite: 'auto',
        duration: 0.1,
      });
    },
  });
});

pinButtons.forEach((pinButtons) => {
  ScrollTrigger.create({
    trigger: pinButtons,
    start: "bottom bottom",
    toggleActions: "play none none none",
    scrub: true,
    onUpdate: (self) => {
      const progress = self.progress;
      const y = -100 * progress;
      gsap.to(pinButtons, {
        y: y,
        ease: 'none',
        overwrite: 'auto',
        duration: 0.1,
      });
    },
  });
});
